import { emailRegEx } from 'ecs-react-components/dist/index.es';

export const validations = {
  contactFirstName: {
    required: true,
  },
  contactLastName: {
    required: true,
  },
  relationshipId: {
    required: true,
  },
  isPrimaryContact: {
    required: false,
  },
  isNextOfKin: {
    required: false,
  },
  providesTransport: {
    required: false,
  },
  usePatientAddress: {
    required: false,
  },
  address1: {
    required: false,
  },
  address2: {
    required: false,
  },
  city: {
    required: false,
  },
  zipCode: {
    required: false,
  },
  state: {
    required: false,
  },
  country: {
    required: false,
  },
  homePhone: {
    required: false,
  },
  isOkToLeaveMsgHome: {
    required: false,
  },
  mobilePhone: {
    required: false,
  },
  isOkToLeaveMsgMobile: {
    required: false,
  },
  workPhone: {
    required: false,
  },
  isOkToLeaveMsgWork: {
    required: false,
  },
  contactEmail: {
    required: false,
    validateOnBlur: false,
    promise: (fieldName, fieldValue) => (
      new Promise((resolve, reject) => {
        if (fieldValue && !emailRegEx.test(fieldValue)) {
          reject();
        } else {
          resolve();
        }
      })),
  },
  preferredCommunicationId: {
    required: false,
  },
  communicationLanguageId: {
    required: true,
  },
};
